import React, { Component } from "react";
import { observer } from "mobx-react";
import {
    fn_change_init_view,
} from "../../../../function/FnBodySetting";
import { fn_change_up_sound } from "../../../../function/FnBodySetting";

@observer
class OnboardingView extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;

        return (
            <div className={"layer_comm layer_common_type " + ((layerStore.getLayerOnboardingView || (typeof rootStore.settingStore.getInitView !== 'undefined') && rootStore.settingStore.getInitView == "N") ? ' layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section">
                            <div className="info">
                                <div className="top">
                                    <span className="top_txt">사용안내</span>
                                    <span className="top_sub">배달매니저 이렇게 사용하세요!</span>
                                </div>
                                <div className="tit">
                                    <p className="txt">배달매니저 3분 가이드</p>
                                    <p className="tip">※ <strong>처음 설치한 사장님</strong>께서는 순서대로 따라해주세요</p>
                                </div>
                                <ul className="content">
                                    <li className="step" onClick={event => {
                                        layerStore.setChangeOnboardingStep("01");
                                        layerStore.setLayerOnboardingView(false);
                                    }}>
                                        <span className="num">Step 01.</span>
                                        <span className="tit">주문접수<br />프린트 설정</span>
                                        <span className="ico img1"></span>
                                    </li>
                                    <li className="step" onClick={event => {
                                        layerStore.setChangeOnboardingStep("02");
                                        layerStore.setLayerOnboardingView(false);
                                    }}>
                                        <span className="num">Step 02.</span>
                                        <span className="tit">배달앱<em> (배/쿠/요)</em><br />주문처리</span>
                                        <span className="ico img2"></span>
                                    </li>
                                    <li className="step" onClick={event => {
                                        layerStore.setChangeOnboardingStep("03");
                                        layerStore.setLayerOnboardingView(false);
                                    }}>
                                        <span className="num">Step 03.</span>
                                        <span className="tit">전화 (CID)<br />주문접수</span>
                                        <span className="ico img3"></span>
                                    </li>
                                    <li className="step" onClick={event => {
                                        layerStore.setChangeOnboardingStep("04");
                                        layerStore.setLayerOnboardingView(false);
                                    }}>
                                        <span className="num">Step 04.</span>
                                        <span className="tit">매출 자동<br />집계 설정</span>
                                        <span className="ico img4"></span>
                                    </li>
                                </ul>
                                <p className="sub">• 사용안내는 [왼쪽 최상단 메뉴 버튼 &gt; 사용안내] 통해서 언제든지 확인하실 수 있습니다.
                                    <br />• 직원 교육시 간편하게 활용하세요
                                </p>
                            </div>
                        </div>

                        <div className="btn_close">
                            <button
                                onClick={event => { event.preventDefault(); layerStore.setLayerOnboardingView(false); fn_change_init_view(rootStore); }}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OnboardingView;